import React from 'react';
import GridListTile, {
  GridListTileProps,
} from '@material-ui/core/GridListTile';

const GridListTileNext: React.FC<GridListTileProps> = props => (
  <GridListTile {...props} />
);

export default GridListTileNext;
